let filters;

const debounce = (func, delay) => {
	let debounceTimer
	return function() {
		const context = this
		const args = arguments
			clearTimeout(debounceTimer)
				debounceTimer
			= setTimeout(() => func.apply(context, args), delay)
	}
}

function initStoriesList() {
    const storiesList = document.querySelectorAll('.block-stories');
    

    storiesList.forEach(element => {
        initVariables(element);

        const searchForm = element.querySelector('.search-form');
        const textSearch = element.querySelector('.form-control.search');
        const btnLoadMore = element.querySelector('#load-more');
        const container = element.querySelector('.stories-container.post-container');
        const slcArchivePostDate = element.querySelector('.archive-post-date');

        //
        // EVENTS
        //
        if(btnLoadMore) {
            btnLoadMore.addEventListener('click', () => {
                const paged = filters.paged++;
    
                filters = {
                    paged,
                    ...filters,
                }
    
                loadPost(container, btnLoadMore, false);
            });
        }

        //
        // SEARCH FORM
        //
        if(searchForm)
            searchForm.addEventListener('submit', (e) => e.preventDefault());

        if(textSearch) {
            textSearch.addEventListener('input', debounce(() => {
                const search = textSearch.value;

                filters = {
                    ...filters,
                    search
                }

                if(filters.paged)
                    filters.paged = 1;

                if(btnLoadMore)
                    btnLoadMore.removeAttribute('disabled', false);

                loadPost(container, btnLoadMore);

            }, 800));
        }

        if(slcArchivePostDate) {
            slcArchivePostDate.addEventListener('change', (e) => {
                const date = e.currentTarget.value;

                if( !date ) 
                    return false;

                if(filters.paged)
                    filters.paged = 1;

                filters = {
                    ...filters,
                    date
                }

                if(btnLoadMore)
                btnLoadMore.removeAttribute('disabled', false);

                loadPost(container, btnLoadMore);

            });
        }

    });
}

function initVariables(container) {
    const perPage = container.dataset.perPage;

    filters = {
        posts_per_page: perPage,
        paged: 1,
    }
}

//
// Helper functions
//
// eslint-disable-next-line no-shadow
const api = (filters)  =>{
    const data = {
        // eslint-disable-next-line no-undef
        nonce: posts_list_object.nonce,
        action: 'load_stories_list',
        ...filters
    }

    return jQuery.ajax({
      // eslint-disable-next-line no-undef
      url: posts_list_object.ajax_url,
      type: 'GET',
      data,
    });
}

function addCardsEvent($cards) {
    return $cards;
    // $cards.filter('.post-list').each((index, card) => {
	// 	const link = card.querySelector('a');
	// 	const url = link.getAttribute('href');
	// 	const target = link.getAttribute('target');
		
	// 	card.addEventListener('click', () => {
	// 		if(target === '_blank') {
	// 			window.open(url);
	// 		}else {
	// 			window.location.href = url;
	// 		}
	// 	});
	// })
}

function loadPost(container, btn, isEmptyChildren = true) {
    const errorMessages = container.querySelectorAll('.error-message');
    errorMessages.forEach(message => message.remove());

    if(isEmptyChildren) {
        jQuery(container).html(loaderElements(filters.posts_per_page));
    }else {
        jQuery(container).append(loaderElements(filters.posts_per_page));
    }

    api(filters).done((response) => {
        const cards = jQuery(response);

        addCardsEvent(cards);
        if(isEmptyChildren)  {
            jQuery(container).html(cards);
        }else {
            jQuery(container).find('.card.skeleton--container').remove();
            jQuery(container).append(cards);
        }


        //
        // ERROR MESSAGE
        //
        if(!cards.length) {
            jQuery(container).append(`<h5 class="error-message">No more results found.</h5>`);

            if(btn)
                btn.setAttribute('disabled', true);
        }

    });
}

function loaderElements(count) {

    const card = `<div class="card post-list skeleton--container">
                    <div class="card-image skeleton">
                    </div><div class="card-body">
                        <div class="skeleton--text"></div>
                        <div class="skeleton--text" style="width: 80%;"></div>

                        <div class="skeleton--text" style="margin-top: 1em"></div>
                        <div class="skeleton--text"></div>
                        <div class="skeleton--text" style="width: 75%;"></div>
                    </div>
                </div>`;

    let loaders = '';

    for (let i = 0; i < count; i++) {
        loaders+= card;
    }

    return jQuery(loaders);
}

/**
 * On Loads
 */
document.addEventListener('DOMContentLoaded', () => {
    initStoriesList();
});
